module.exports = __webpack_public_path__ + "images/0a47b1125ff5b72e329347881af2c500-MPOS.png";